module.exports = __webpack_public_path__ + "img/es.71047001.svg";